import {
  SET_SELECTED_SPECIAL_TIMED_AUCTION,
  SET_SPECIAL_ELIGIBILITY_OPEN,
} from "./types";

const initialState = {
  specialEligibilityOpen: false,
  selectedSpecialTimedAuction: null,
};

const SellerSpecialEligibilityReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SPECIAL_ELIGIBILITY_OPEN:
      return { ...state, specialEligibilityOpen: action.payload };
    case SET_SELECTED_SPECIAL_TIMED_AUCTION:
      return { ...state, selectedSpecialTimedAuction: action.payload };
    default:
      return state;
  }
};

export default SellerSpecialEligibilityReducer;
